import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import { cx } from './cx';

/**
 * Surface primitive. `surface` picks the fill; `bordered` adds the hairline;
 * `pad` picks interior padding. Quiet elevation only - no heavy shadows.
 */
export function Card({
  surface = 'surface',
  bordered = true,
  pad = 'md',
  className,
  children,
  ...rest
}: {
  surface?: 'surface' | 'bone';
  bordered?: boolean;
  pad?: 'none' | 'sm' | 'md' | 'lg';
  className?: string;
  children: ReactNode;
} & Omit<ComponentPropsWithoutRef<'div'>, 'className' | 'children'>) {
  // Compact by mandate: md (the default) is 16px, not the airy 24-32 SaaS default.
  const padCls = { none: 'p-0', sm: 'p-3', md: 'p-4', lg: 'p-6' }[pad];
  return (
    <div
      className={cx(
        surface === 'bone' ? 'bg-bone' : 'bg-surface',
        bordered && 'border border-border',
        'rounded-md',
        padCls,
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
